import { config as userConfig } from 'virtual:tidal-sandbox-list'
import merge from 'lodash.merge'
import { defaultConfig } from '../../../shared/defaultConfig.js'
import type { TidalSandboxConfig } from '../../../shared/types.js'

console.groupCollapsed('%c[Tidal Sandbox]', 'color: orange; font-weight: bold;')

if (Object.keys(userConfig).length === 0) {
  console.log('No custom config found.')
} else {
  console.log(`Custom config found:`)
  console.log(userConfig)
}
console.groupEnd()

export const config: TidalSandboxConfig = merge(defaultConfig, userConfig)

// console.log('Final config', config)
